import type { FC } from 'react';
import { useContext } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import {
  getActiveSection,
  getCurrentProductsSectionCount,
  getCurrentProductsSectionType,
} from '../../../selectors/studio';
import ProductsBreadcrumbs from '../ProductsBreadcrumbs';
import ProductsTabs from '../ProductsTabs';
import FreeBoostsPromoBanner from '../../FreeBoostsPromoBanner';
import CreateOriginalButton from './CreateOriginalButton';
import { StudioSection } from '../../../types/store';
import { ProductType } from '../types';

import s from './ProductsHeader.scss';

interface Props {
  className?: string;
}

const ProductsHeader: FC<Props> = ({ className }) => {
  const isDesktop = !useContext(MobileContext);
  const activeSection = useSelector(getActiveSection);
  const productsCount = useSelector(getCurrentProductsSectionCount);
  const productType = useSelector(getCurrentProductsSectionType);
  const showProductsTabs = [
    StudioSection.PRODUCTS_EXCLUSIVE,
    StudioSection.PRODUCTS_EXCLUSIVE_UNLISTED,
    StudioSection.PRODUCTS_PCP,
    StudioSection.PRODUCTS_PCP_UNLISTED,
    StudioSection.PRODUCTS_TIER,
    StudioSection.PRODUCTS_TIER_UNLISTED,
    StudioSection.PRODUCTS_ORIGINAL,
    StudioSection.PRODUCTS_ORIGINAL_UNLISTED,
  ].includes(activeSection);
  const showProductsCount =
    !showProductsTabs && activeSection !== StudioSection.PRODUCTS_LOBBY;
  const isOriginalsSection = productType === ProductType.Original;

  // on mobile we render the banner from the products list
  const showBoostPromoBanner = isDesktop;

  return (
    <div
      className={cn(s['root'], showProductsTabs && s['has-tabs'], className)}
    >
      <div className={s['products-title']}>
        <ProductsBreadcrumbs />
        {showProductsCount && (
          <div className={s['products-count']}>{productsCount}</div>
        )}
      </div>
      {showProductsTabs && (
        <div className={s['tabs-and-banner']}>
          <ProductsTabs className={s['products-tabs']} />
          <div className={s['actions']}>
            {showBoostPromoBanner && <FreeBoostsPromoBanner />}
            {isOriginalsSection && isDesktop && <CreateOriginalButton />}
          </div>
        </div>
      )}
    </div>
  );
};
ProductsHeader.displayName = 'ProductsHeader';

export default ProductsHeader;
